module.exports = __webpack_public_path__ + "static/media/level3.a6de948a.png";